import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { postCoreDataSecurityAccessAuditExportSlice } from './post';

export const coreDataSecurityAccessAuditExportReducers = combineReducers({
	post: postCoreDataSecurityAccessAuditExportSlice.asyncReducers
});

export const coreDataSecurityAccessAuditExportWatchers = combineAllWatchers([
	postCoreDataSecurityAccessAuditExportSlice.asyncWatchers
]);
